import Icon from "../selfcare/Icon.tsx";
import PhoneNumberSpanComponent from "./PhoneNumberSpanComponent.tsx";
import {useEffect, useState} from "react";
import CallMeFormComponent from "./CallMeFormComponent.tsx";
import LoaderSpinner from "../loaders/LoaderSpinner.tsx";
import {CallMeState, getCallMeOpeningHours} from "../../util/callMe.ts";
import IconPhone from "../icons/IconPhone.tsx";
import {CallMePhoneNumberSet} from "../../util/contact.ts";

export default function CallMeComponent(props: { phoneNumberSet: CallMePhoneNumberSet }) {
    const [callMeState, setCallMeState] = useState<CallMeState>()
    const [error, setError] = useState<boolean>(false)

    useEffect(() => {
        getCallMeOpeningHours()
            .then((d) => setCallMeState(d))
            .catch(() => setError(true))
    }, [])

    if (error) {
        return
    }

    if (callMeState === undefined) {
        return <LoaderSpinner/>
    }

    return (
        <div className="rto rto--contact">
            <p>
                Har du brug for hjælp til køb af nyt internet?
            </p>
            {callMeState === CallMeState.InboundOpen &&
                <CallCenterInboundOpen phone_no_primary={props.phoneNumberSet.primary} phone_no_secondary={props.phoneNumberSet.secondary !== undefined ? props.phoneNumberSet.secondary : props.phoneNumberSet.primary}/>}
            {callMeState !== CallMeState.InboundOpen && (
                <p>
                    Lad os ringe dig op &ndash; vores imødekommende rådgivere sidder klar til at hjælpe dig med at finde den bedste internetløsning til dit hjem.
                </p>
            )}
            {callMeState === CallMeState.OutboundOpen && (
                <p>Vi ringer inden for en time.</p>
            )}
            {callMeState === CallMeState.InboundAndOutboundClosed && (
                <p>Vi ringer hurtigst muligt.</p>
            )}
            {callMeState !== CallMeState.InboundOpen && (
                <CallMeFormComponent/>
            )}
        </div>
    )
}

function CallCenterInboundOpen(props: { phone_no_primary: string, phone_no_secondary: string }) {
    return <>
        <p>
            Ring til os &ndash; vores imødekommende rådgivere sidder klar til at hjælpe dig med at finde den bedste internetløsning til dit hjem.
        </p>
        <a className="call-button hide-on-small-devices" href={`tel:+45${props.phone_no_primary}`}>
            <span>Bestil på <PhoneNumberSpanComponent phoneNo={props.phone_no_primary}/></span>
            <Icon component={IconPhone}/>
        </a>
        <a className="call-button hide-on-large-devices" href={`tel:+45${props.phone_no_secondary}`}>
            <span>Bestil på <PhoneNumberSpanComponent phoneNo={props.phone_no_secondary}/></span>
            <Icon component={IconPhone}/>
        </a>
    </>
}
